// extracted by mini-css-extract-plugin
export var card = "personal-training-item-card-module--card--gT4S9";
export var iconWrapper = "personal-training-item-card-module--icon-wrapper--mMzKN";
export var img = "personal-training-item-card-module--img--Wy+Y8";
export var imgWrapper = "personal-training-item-card-module--img-wrapper--JLvnP";
export var label = "personal-training-item-card-module--label--t9Y6V";
export var ratioClass = "personal-training-item-card-module--ratio-class--9AqRM";
export var title = "personal-training-item-card-module--title--YdQLE";